export const BAD_CREDENTIALS = 401;
export const NOT_AUTHORIZED = 403;
export const FORM_FIELDS_ERROR = 422;
